import { useUserQuery } from "src/store/user";

export const useIsPiiFreeBroker = () => {
  const { data: user } = useUserQuery();

  return !!user?.broker.isPiiFreeBroker;
};
